module.exports = __webpack_public_path__ + "ae26521aa778d0a4bfe2db7530b90f8c.svg";